import { render, staticRenderFns } from "./PageBanner.vue?vue&type=template&id=6ea8efc5&scoped=true&"
import script from "./PageBanner.vue?vue&type=script&lang=js&"
export * from "./PageBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea8efc5",
  null
  
)

export default component.exports